import * as React from "react"
import {Check, ChevronsUpDown} from "lucide-react"
import {cn} from "@/lib/utils"
import {Button} from "@/components/ui/button"
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,} from "@/components/ui/command"
import {Popover, PopoverContent, PopoverTrigger,} from "@/components/ui/popover"

export interface MultiSelectProps<T = any> {
    options: T[]
    selected: T[]
    onChange?: (selected: T[]) => void;
    onChangeKey?: (selected: T[]) => void;
    placeholder?: T;
    optionKey?: string,
    optionValue?: string
}

export function MultiSelect({
                                options,
                                selected,
                                onChange,
                                onChangeKey,
                                placeholder = "Select items...",
                                optionValue = "name",
                                optionKey = "id",
                            }: MultiSelectProps) {
    const [open, setOpen] = React.useState(false)

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                >
                    {selected.length > 0
                        ? `${selected.length} selected`
                        : placeholder}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50"/>
                </Button>
            </PopoverTrigger>
            <div className="z-40 bg-yellow-400">
                <PopoverContent className="w-full p-0 bg-popover">
                    <Command>
                        <CommandInput placeholder="Search items..."/>
                        <CommandEmpty>No item found.</CommandEmpty>
                        <CommandGroup>
                            <CommandList>
                                {options.map((option) => (
                                    <CommandItem
                                        key={option[optionKey]}
                                        onSelect={() => {

                                            if (!(onChangeKey || onChange)) {
                                                return;
                                            }

                                            const selections = selected.includes(option)
                                                ? selected.filter((item) => item !== option)
                                                : [...selected, option]
                                            onChange && onChange(selections)
                                            onChangeKey && onChangeKey(selections.map(s => s[optionKey]))
                                            setOpen(true)
                                        }}
                                    >
                                        <Check
                                            className={cn(
                                                "mr-2 h-4 w-4",
                                                selected.includes(option) ? "opacity-100" : "opacity-0"
                                            )}
                                        />
                                        {option[optionValue]}
                                    </CommandItem>
                                ))}
                            </CommandList>
                        </CommandGroup>
                    </Command>
                </PopoverContent>
            </div>
        </Popover>
    )
}
